async function fetchCart() {
  return new Promise((resolve, reject) => {
    fetch('/cart.js')
      .then(response => response.json())
      .then(data => {
        resolve(data);
      })
      .catch(error => {
        reject(error);
      });
  })
}

async function fetchCartWithAssemblyMetafields() {
  return new Promise((resolve, reject) => {
    fetch("/?sections=micasa-assembly-cart-json", {
      headers: {
        method: "GET",
        Accept: "application/json"
      }
    })
      .then(r => r.json())
      .then(data => {
        const section = data["micasa-assembly-cart-json"];
        const sectionDOM = new DOMParser().parseFromString(section, "text/html");
        const scripts = sectionDOM.querySelectorAll("script")
        let cart = JSON.parse(scripts[0].innerText);
        let assemblyItems = JSON.parse(scripts[1].innerText);

        resolve({
          ...cart,
          assemblyItems: assemblyItems
        });
      })
      .catch(error => {
        reject(error);
      });
  })
}

const originalFetch = window.fetch;
async function fetchAssemblyItemPrice(assemblyItems) {
  return new Promise((resolve, reject) => {
    originalFetch("/apps/micasa/api/v1/carts/assembly", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ items: assemblyItems }),
    })
      .then(r => r.json())
      .then(data => {
        if (Object.keys(data.data).length === 0) {
          resolve(null)
        } else {
          resolve(data.data);
        }
      })
      .catch(error => {
        console.error("Error fetching assembly item price", error);
        reject(error);
      });
  })
}

window.fetch = async function(...args) {
  const [url] = args;
  
  if (typeof url === 'string' && (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update'))) {
    async function alteredFetch (...args) {
      const response = await originalFetch.apply(this, args);
      const assemblyProductId = window.assemblyProductId;
      if (!assemblyProductId) {
        console.error("Assembly product ID not found");
        return;
      }

      fetchCartWithAssemblyMetafields().then(cart=>{
        const isAssemblyProductInCart = cart.items.find(prop => prop.id.toString() === assemblyProductId) != null;
        const isAnyAssemblyFlagInCart = cart.items.find(prop => prop.id.toString() !== assemblyProductId && prop.properties["__assembly"] === "true") != null;

        let requests = [];
        const sections = []
        const isDrawer = document.querySelector('#CartDrawer[open]');
        const isCart = document.querySelector('.cart');
        if (isDrawer != null) {
          sections.push(isDrawer.getAttribute('data-section-id'));
        }
        
        if(isCart) {
          const closestSection = isCart.closest('.shopify-section');
          if (!closestSection) {
            console.error("Failed to find closest section for cart");
          } else {
            sections.push(closestSection.getAttribute('id')?.replace('shopify-section-',''));
          }
        }

        if (isAnyAssemblyFlagInCart && !isAssemblyProductInCart) {
          // ADD ASSEMBLY PRODUCT TO CART WITH NEW PRICE
          requests.push(new Promise((resolve) => {
            fetchAssemblyItemPrice(cart.assemblyItems)
              .then(assemblyResponse => {
                originalFetch("/cart/add", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                  },
                  body: JSON.stringify({
                    items: [{
                      id: assemblyProductId,
                      quantity: 1,
                      properties: {
                        __assembly_price: assemblyResponse.unitprice
                      }
                    }]
                  })
                })
                  .then((data) => data.json())
                  .then((data) => {
                    resolve(data);
                  })
              })
          }))
        } else if (!isAnyAssemblyFlagInCart && isAssemblyProductInCart) {
          // REMOVE ASSEMBLY PRODUCT
          requests.push(originalFetch("/cart/change", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
            },
            body: JSON.stringify({
              id: assemblyProductId,
              quantity: 0,
              sections: sections,
            })
          }))
        } else if (isAnyAssemblyFlagInCart && isAssemblyProductInCart) {
          // UPDATE ASSEMBLY PRODUCT PRICE
          requests.push(new Promise((resolve) => {
            fetchAssemblyItemPrice(cart.assemblyItems)
              .then(assemblyResponse => {
                originalFetch("/cart/change", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                  },
                  body: JSON.stringify({
                    id: assemblyProductId,
                    quantity: 1,
                    sections: sections,
                    properties: {
                      __assembly_price: assemblyResponse.unitprice
                    }
                  })
                })
                  .then((data) => data.json())
                  .then((data) => {
                    resolve(data);
                  })
              })
          }))
        }

        // Check for disposable items
        const disposalProductId = window.disposalProductId;
        if (!disposalProductId) {
          console.error("Disposal product ID not found");
        } else {
          const isDisposableItem = cart.items.find(item => item.id.toString() === disposalProductId.toString());
          if (!isDisposableItem) {
            // console.log("No disposable item in cart", disposalProductId, cart.items);
          } else {
            requests.push(new Promise(async (resolve) => {
              const sectionRendererApi = await originalFetch("/?sections=micasa-disposal-item-count-in-cart", {
                headers: {
                  method: "GET",
                  Accept: "application/json"
                }
              })
              const sectionRendererApiJSON = await sectionRendererApi.json();
              const sectionDOM = new DOMParser().parseFromString(sectionRendererApiJSON['micasa-disposal-item-count-in-cart'], 'text/html');
              const itemCount = sectionDOM.querySelector('div').innerText;
              const parsedItemCount = parseInt(itemCount);
              if (parsedItemCount < 1) {
                await originalFetch("/cart/change", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                  },
                  body: JSON.stringify({
                    id: isDisposableItem.key,
                    quantity: 0
                  })
                })
              }
              resolve()
            }))
          }
        }

        if (requests.length != 0) {
          Promise.all(requests).then(async () => {
            const cartJson = await (
              await fetch(`${FoxTheme.routes.cart_url}`, {
                ...FoxTheme.utils.fetchConfig(),
              })
            ).json();
            const sectionRendererApi = await originalFetch("/?sections="+sections.join(','), {
              headers: {
                method: "GET",
                Accept: "application/json"
              }
            })
            
            cartJson['sections'] = (await sectionRendererApi.json());
            FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
          });
        }
      });
      return response;
    }
    return alteredFetch(...args);
  }
  return originalFetch.apply(this, args);
};

// fetchCart().then(cart => console.log(cart));
document.addEventListener('click', async (e)=>{
  if (e.target.matches("button[name='service_assembly']")) {
    // Handle the button click event
    e.preventDefault();
    e.target.classList.add("is-loading");
    e.target.setAttribute("disabled", "true");

    const loadingSpinners = e.target.querySelector('.loading__spinner');
    loadingSpinners.classList.remove('hidden');
    const cart = await fetchCart();
    const lineId = e.target.getAttribute('data-line-id');

    const lineIndex = cart.items.findIndex(item => item.id.toString() === lineId);
    if (lineIndex == -1) {
      console.error("Line item not found");
      return;
    }
    const line = cart.items[lineIndex];
    const isServiceAlreadyAdded = line.properties["__assembly"] === "true";

    await fetch("/cart/change", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        id: line.key,
        quantity: line.quantity,
        properties: {
          __assembly: isServiceAlreadyAdded ? "false" : "true"
        }
      })
    })
  } else if (e.target.matches("button[name='service_disposal']")) {
    const disposalProductId = window.disposalProductId;
    if (!disposalProductId) {
      console.error("Disposal product ID not found");
      return;
    }
    e.target.classList.add("is-loading");
    e.target.setAttribute("disabled", "true");

    const loadingSpinners = e.target.querySelector('.loading__spinner');
    loadingSpinners.classList.remove('hidden');
    
    const cart = await fetchCart();
    const isDisposalAdded = cart.attributes?.disposal === 'true';
    await fetch("/cart", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        attributes: {
          disposal: isDisposalAdded ? 'false' : 'true'
        }
      })
    })
    
    const sections = []
    const isDrawer = document.querySelector('#CartDrawer[open]');
    const isCart = document.querySelector('.cart');
    if (isDrawer != null) {
      sections.push(isDrawer.getAttribute('data-section-id'));
    } 
    
    if(isCart) {
      const closestSection = isCart.closest('.shopify-section');
      if (!closestSection) {
        console.error("Failed to find closest section for cart");
      } else {  
        sections.push(closestSection.getAttribute('id')?.replace('shopify-section-',''));
      }
    }
    
    const disposalLine = cart.items.find(item => item.id.toString() === disposalProductId.toString());
    let request = null
    if (isDisposalAdded) {
      // remove disposal product

      if (disposalLine) {
        request = await fetch("/cart/change", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({
            id: disposalLine.key,
            quantity: 0,
            sections: sections
          })
        })
      }
    } else {
      // add disposal product
      if (!disposalLine) {
        request = await fetch("/cart/add", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({
            items: [{
              id: disposalProductId,
              quantity: 1
            }]
          })
        })
      }
    }

    const cartJson = await (
      await fetch(`${FoxTheme.routes.cart_url}`, {
        ...FoxTheme.utils.fetchConfig(),
      })
    ).json();
    
    let renderedSections = null;
    if (request) {
      const data = await request.json();
      renderedSections = data['sections'];
    }
    if (!renderedSections) {
      const sectionRendererApi = await originalFetch("/?sections="+sections.join(','), {
        headers: {
          method: "GET",
          Accept: "application/json"
        }
      })
      
      renderedSections = (await sectionRendererApi.json());
    }
    
    cartJson['sections'] = renderedSections;
    FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });

    e.target.classList.remove("is-loading");
    e.target.removeAttribute("disabled");

    loadingSpinners.classList.add('hidden');
  }
})